import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import PrivateRoute from "./utils/PrivateRoute";
import { HomeRoute, LoginRoute } from "./components/AuthRoutes";
import Dashboard from "./pages/Dashboard";
import Explore from "./pages/Explore";
import Internships from "./pages/Internships";
import Hackathons from "./pages/Hackathons";
import Placements from "./pages/Placements";
import SavedInternships from "./pages/SavedInternships";
import AdminPage from "./pages/AdminPage";
import UnauthorizedPage from "./pages/UnauthorizedPage";
import PostInternship from "./pages/PostInternships";
import EditInternships from "./pages/EditInternships";
import EditInternshipForm from "./components/EditInternshipForm";
import ManageOpportunities from "./pages/ManageOpportunities";
import ManageHackathonsPanel from "./pages/ManageHackathonsPanel";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<HomeRoute />} />
          <Route path="/login" element={<LoginRoute />} />
          <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/explore" element={<PrivateRoute><Explore /></PrivateRoute>} />
          <Route path="/internships" element={<PrivateRoute><Internships /></PrivateRoute>} />
          <Route path="/hackathons" element={<PrivateRoute><Hackathons /></PrivateRoute>} />
          <Route path="/placements" element={<PrivateRoute><Placements /></PrivateRoute>} />
          <Route path="/saved-internships" element={<PrivateRoute><SavedInternships /></PrivateRoute>} />
          <Route path="/unauthorized" element={<PrivateRoute><UnauthorizedPage /></PrivateRoute>} />
          <Route path="/manage-opportunities" element={<PrivateRoute roleRequired="admin"><ManageOpportunities /></PrivateRoute>} />
          <Route path="/post-internships" element={<PrivateRoute roleRequired="admin"><PostInternship /></PrivateRoute>} />
          <Route path="/edit-internships" element={<PrivateRoute roleRequired="admin"><EditInternships /></PrivateRoute>} />
          <Route path="/edit-internship/:id" element={<PrivateRoute roleRequired="admin"><EditInternshipForm /></PrivateRoute>} />
          <Route
            path="/manage-hackathons"
            element={
              <PrivateRoute roleRequired="admin">
                <ManageHackathonsPanel />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <PrivateRoute roleRequired="admin">
                <AdminPage />
              </PrivateRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  </React.StrictMode>
);
